import ErrorPanel from "./ErrorPanel";

export default ErrorPanel;